// src/components/MarkdownPage.js
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Markdown from './Markdown';

const MarkdownPage = () => {
    const { post } = useParams();
    const [content, setContent] = useState('');

    useEffect(() => {
        import(`../resources/posts/${post}.md`)
            .then(res => fetch(res.default))
            .then(res => res.text())
            .then(text => setContent(text))
            .catch(() => setContent('# Page not found'));
    }, [post]);

    return <Markdown content={content} />;
};

export default MarkdownPage;
